/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import * as adminConst from './constants'
import { notification } from 'antd'
import { adminServices } from '../../../services'
import { FormSelect } from '../../../sharedComponents/form-select'
import { useSelector } from 'react-redux'
import { dispatch, select } from '../../../redux/store'

const MakeUserAdmin = () => {
  const userObj = {
    role_id: '',
    user_id: ''
  }

  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState(userObj)

  const { allRoles } = useSelector(({ roles }) => roles)
  const exitingUsers = useSelector(select.users.getUsersNotAdmin)

  useEffect(() => {
    dispatch.users.getAllusers({ shouldUseCache: false, showAll: true })
  }, [])

  useEffect(() => {
    if (allRoles.length <= 0) {
      dispatch.roles.getAllRoles()
    }
  }, [])

  const onChangeText = ({ target }) => {
    setUser({ ...user, [target.name]: target.value })
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)
      const { data } = await adminServices.makeExistingUserAdmin(user)

      if (data.success) {
        notification.success({
          message: 'Thanks',
          description: data.message
        })
        setUser(userObj)
      }
      dispatch.users.getAllusers({ shouldUseCache: false, showAll: true })

      setLoading(false)
    } catch (error) {
      notification.error({
        message: 'Something went wrong'
      })
      setLoading(false)
    }
  }

  return (
    <main className='w-full flex-grow p-4 bg-white shadow-lg'>
      <div className='mt-4'>
        <h3 className='font-bold text-lg'>{adminConst.MAKE_USER_ADMIN}</h3>
      </div>

      <div className='mt-8'>
        <div className='w-full md:w-8/12 px-2 mb-6'>
          <span className='text-sm text-gray-900  font-semibold'>{adminConst.USER}</span>
          <FormSelect
            options={exitingUsers.map(({ first_name: firstName, last_name: lastName, id }) => ({
              name: `${firstName + ' ' + lastName}`,
              value: id
            }))}
            className='form-control'
            value={user.user_id}
            onChange={onChangeText}
            label='Select User'
            name='user_id'
          />
        </div>
        <div className='w-full md:w-8/12 px-2 mb-6 m-0'>
          <span className='text-sm text-gray-900 font-semibold'>{adminConst.ROLE}</span>
          <FormSelect
            options={allRoles.map(({ role_id: roleId, role_title: roleTitle }) => ({
              name: roleTitle,
              value: roleId
            }))}
            name='role_id'
            value={user.role_id}
            onChange={onChangeText}
            label='Select Roles'
            className='form-control'
          />
        </div>
        <div>
          <button
            onClick={handleSubmit}
            className='bg-primary text-base mt-6 py-3 px-4 border rounded-lg hover:bg-primary-200 text-white hover:text-gray-50;'
          >
            {loading ? <i className='fa fa-spin fa-spinner mr-2 font-bold text-lg' /> : ''}{' '}
            {adminConst.MAKE_ADMIN}
          </button>
        </div>
      </div>
    </main>
  )
}

export default MakeUserAdmin
